module.exports = __webpack_public_path__ + "static/media/grafite.2d8ad118.jpg";